import { Icon } from "@tremor/react";
import "./styles.css";
import {
  ArrowLeftOnRectangleIcon,
  BuildingStorefrontIcon,
  TruckIcon,
  UserPlusIcon,
  UsersIcon,
  ChatBubbleLeftRightIcon,
} from "@heroicons/react/24/solid";
import urlImage from "../../assets/logo.png";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/auth";
import { getUnreadMessagesFromAPI } from "../../store/chats/thunks";
//TODO: Change to Component list
//TODO: Put proptypes
// eslint-disable-next-line react/prop-types
const ListItemComponent = ({ title, urlToGo, icon, extraInfo = null }) => {
  return (
    <li className="my-3 text-tremor-content-strong dark:text-dark-tremor-content-emphasis list-link">
      <Link to={urlToGo} style={{ position: "relative" }}>
        <Icon style={{ marginLeft: "9px" }} icon={icon}></Icon>
        <span className="links_name ">{title}</span>
        {extraInfo > 0 && (
          <span className="absolute bottom-2 right-2 text-[10px] font-bold bg-red-600 text-white w-5 h-5 rounded-full flex items-center justify-center shadow-md">
            {extraInfo}
          </span>
        )}
      </Link>
      <span className="tooltip">{title}</span>
    </li>
  );
};
//TODO: Put proptypes
// eslint-disable-next-line react/prop-types
export const NavSideBarComponent = ({ setActiveNavLayout }) => {
  const { name, lastName } = useSelector((state) => state.auth);
  const { unreadMessages } = useSelector((state) => state.chats);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isActiveNav, setActiveNav] = useState(false);
  const toggleNavBar = () => {
    setActiveNavLayout(!isActiveNav);
    setActiveNav(!isActiveNav);
  };
  useEffect(() => {
    dispatch(getUnreadMessagesFromAPI());

    const interval = setInterval(() => {
      dispatch(getUnreadMessagesFromAPI());
    }, 60000);

    return () => clearInterval(interval);
  }, [dispatch]);

  const logOut = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <>
      <div
        className={`sidebar bg-tremor-background-nav dark:bg-dark-tremor-background ${
          isActiveNav ? "active" : ""
        }`}
        style={{ zIndex: "1001" }}
      >
        <div className="logo-content " onClick={toggleNavBar}>
          <div className="logo">
            <img src={urlImage} className="image-logo" />
            <div
              className={`logo-name text-tremor-content-strong dark:text-dark-tremor-content-emphasis ml-2 ${
                isActiveNav ? "transition-opacity ease-in-out delay-500" : ""
              }`}
            >
              Servicios Aduanales RM
            </div>
          </div>
          {/* <i className="bx bx-food-menu" id="btn"></i> */}
        </div>
        <ul className="mt-5">
          <ListItemComponent
            title="Usuarios"
            urlToGo="/admin/"
            icon={UsersIcon}
          />
          <ListItemComponent
            title="Perfiles"
            urlToGo="/admin/profiles"
            icon={UserPlusIcon}
          />
          <ListItemComponent
            title="Clientes"
            urlToGo="/admin/customers"
            icon={BuildingStorefrontIcon}
          />
          <ListItemComponent
            title="Servicios"
            urlToGo="/admin/services"
            icon={TruckIcon}
          />
          <ListItemComponent
            title="Chats"
            urlToGo="/admin/chats"
            icon={ChatBubbleLeftRightIcon}
            extraInfo={unreadMessages}
          />
        </ul>
        <div className="profile-content">
          <div className="profile">
            <div className="profile-details">
              {/* <img src={urlImage} alt="" /> */}
              <div className="user-info">
                <div className="name">{name}</div>
                <div className="job">{lastName}</div>
              </div>
            </div>
            <Icon
              onClick={logOut}
              icon={ArrowLeftOnRectangleIcon}
              id="log-out"
            ></Icon>
          </div>
        </div>
      </div>
    </>
  );
};
